import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, Fragment as _Fragment, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, renderList as _renderList, vModelSelect as _vModelSelect, resolveComponent as _resolveComponent, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-508555ad"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "text-center quickbooks"
}
const _hoisted_2 = {
  key: 1,
  class: "red-warning"
}
const _hoisted_3 = ["href"]
const _hoisted_4 = {
  key: 3,
  style: {"color":"green"}
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Facilities", -1))
const _hoisted_6 = { class: "card-container" }
const _hoisted_7 = { class: "row data" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h2", null, "Self Storage")
], -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h2", null, "Campgrounds")
], -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Self Storage Facilities", -1))
const _hoisted_13 = {
  key: 0,
  class: "container"
}
const _hoisted_14 = { class: "row" }
const _hoisted_15 = ["value"]
const _hoisted_16 = {
  key: 1,
  style: {"min-width":"900px"}
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", null, [
    /*#__PURE__*/_createElementVNode("h3", null, "Facility Name")
  ]),
  /*#__PURE__*/_createElementVNode("th", null, [
    /*#__PURE__*/_createElementVNode("h3", null, "Phone Number")
  ])
], -1))
const _hoisted_18 = {
  key: 2,
  class: "text-center"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Campground Facilities", -1))
const _hoisted_20 = { class: "container" }
const _hoisted_21 = { class: "row" }
const _hoisted_22 = {
  key: 1,
  style: {"min-width":"900px"}
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", null, [
    /*#__PURE__*/_createElementVNode("h3", null, "Facility Name")
  ]),
  /*#__PURE__*/_createElementVNode("th", null, [
    /*#__PURE__*/_createElementVNode("h3", null, "Phone Number")
  ])
], -1))
const _hoisted_24 = {
  key: 2,
  class: "text-center"
}

import { onMounted, ref, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import api from "@virgodev/bazaar/functions/api";
import { storeToRefs } from "pinia";
import { useStore } from "../store";
import moment from "moment";

interface NbCampgroundFacility {
  id: number | string;
  facility_name: string;
  phone_number?: string | null;
}


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore();
const route = useRoute();
const router = useRouter();
const { userData } = storeToRefs(store);
const activeTab = ref((route.query.tab as string) || "");
const searchFacility = ref("");
const filteredFacilities = ref(userData.value.facilities);
const selectedFilter = ref("name");
const status = ref("loading");
const urlForAuth = ref("");
const daysQuickbooksExpires = ref();
const formErrors = ref<Record<string, string[]>>({});
const successQuickbooks = ref(false);
const filterOptions = ref([
  { text: "Facility Name", value: "name" },
  { text: "Phone Number", value: "phone" },
]);

const campgrounds = ref<NbCampgroundFacility[]>([]);
const filteredCampgrounds = ref<NbCampgroundFacility[]>([]);
const searchCampground = ref("");
const campgroundStatus = ref("loading");

watch(
  () => route.query.tab,
  (newTab) => {
    const tab = (newTab as string) || "";
    activeTab.value = tab;
    if (tab === "campground" && !campgrounds.value.length) {
      loadCampgrounds();
    }
  }
);

onMounted(async () => {
  filteredFacilities.value = userData.value.facilities;
  if (userData.value.quickbooks_expire && userData.value.is_staff) {
    let expire_date = moment(userData.value.quickbooks_expire);
    daysQuickbooksExpires.value = moment(expire_date).diff(moment(), "days");
  }

  status.value = "loaded";

  if (!activeTab.value) {
    const hasStorage = userData.value.has_storage_access;
    const hasCampground = userData.value.has_campground_access;
    if (hasStorage && !hasCampground) {
      router.replace({ name: "Home", query: { tab: "storage" } });
      return;
    }
    if (hasCampground && !hasStorage) {
      router.replace({ name: "Home", query: { tab: "campground" } });
      return;
    }
  }

  if (activeTab.value === "campground") {
    loadCampgrounds();
  }
});

async function loadCampgrounds() {
  campgroundStatus.value = "loading";
  try {
    const response = await api({ url: "nb/facilities/", method: "GET" });
    if (response.ok) {
      campgrounds.value = response.body as NbCampgroundFacility[];
      filteredCampgrounds.value = response.body as NbCampgroundFacility[];
    }
  } catch {
    campgrounds.value = [];
    filteredCampgrounds.value = [];
  }
  campgroundStatus.value = "loaded";
}

function searchCampgrounds() {
  const q = searchCampground.value.trim().toLowerCase();
  if (q) {
    filteredCampgrounds.value = campgrounds.value.filter(
      (c) =>
        c.facility_name.toLowerCase().includes(q) ||
        formatPhoneNumber(c.phone_number).toLowerCase().includes(q) ||
        String(c.phone_number || "").includes(q)
    );
  } else {
    filteredCampgrounds.value = campgrounds.value;
  }
}

function formatPhoneNumber(phoneNumber?: string | null) {
  if (!phoneNumber) {
    return "";
  }

  const trimmedPhoneNumber = phoneNumber.trim();
  if (
    trimmedPhoneNumber.startsWith("+") &&
    !trimmedPhoneNumber.startsWith("+1")
  ) {
    return phoneNumber;
  }

  let extension = "";
  let phoneText = phoneNumber;
  const extensionMatch = phoneNumber.match(
    /(?:ext\.?|extension|x)\s*(\d+)\s*$/i
  );
  if (extensionMatch?.index !== undefined) {
    extension = extensionMatch[1];
    phoneText = phoneNumber.substring(0, extensionMatch.index);
  }

  let digits = phoneText.replace(/\D/g, "");
  if (digits.length >= 11 && digits.startsWith("1")) {
    digits = digits.substring(1);
  }
  if (digits.length >= 10) {
    if (!extension && digits.length > 10) {
      extension = digits.substring(10);
    }
    const formatted = `(${digits.substring(0, 3)}) ${digits.substring(
      3,
      6
    )}-${digits.substring(6, 10)}`;
    return extension ? `${formatted} x${extension}` : formatted;
  }

  return phoneNumber;
}
async function quickBooksAuthCheck() {
  successQuickbooks.value = false;
  let url = `auth_check`;
  const responseData = await api({
    url,
    method: "GET",
  });
  if ([200, 201].includes(responseData.status)) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    if (responseData.body.url) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      urlForAuth.value = responseData.body.url;
    }
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    if (responseData.body.Success) {
      successQuickbooks.value = true;
    }
  } else if (responseData.status === 400 || responseData.status === 406) {
    formErrors.value = responseData.body;
  }
}
async function search() {
  if (searchFacility.value.length) {
    status.value = "loading";
    let facilities = userData.value.facilities;

    let searchValue = searchFacility.value.trim();
    if (selectedFilter.value == "phone") {
      filteredFacilities.value = facilities.filter(
        (item) =>
          item.phone_number.includes(searchValue) ||
          item.unformatted_phone_number.includes(searchValue)
      );
    } else {
      searchValue = searchValue.toLowerCase();
      filteredFacilities.value = facilities.filter((item) =>
        item.facility_name.toLowerCase().includes(searchValue)
      );
    }
  } else {
    filteredFacilities.value = userData.value.facilities;
  }
  status.value = "loaded";
}

return (_ctx: any,_cache: any) => {
  const _component_BaseSpinner = _resolveComponent("BaseSpinner")!
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_BaseAlert = _resolveComponent("BaseAlert")!

  return (!_unref(userData).client_user)
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        (_unref(userData).is_staff)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              (_unref(userData).quickbooks_expire)
                ? (_openBlock(), _createElementBlock("h3", {
                    key: 0,
                    class: _normalizeClass(Number(daysQuickbooksExpires.value) <= 3 ? 'red-warning' : '')
                  }, " Quickbooks Connection expires in " + _toDisplayString(daysQuickbooksExpires.value) + " days ( " + _toDisplayString(_unref(moment)(_unref(userData).quickbooks_expire).format("YYYY-MM-DD")) + ") ", 3))
                : (_openBlock(), _createElementBlock("h3", _hoisted_2, " Quickbooks is not connected. Click the button to connect. ")),
              _createElementVNode("button", {
                class: "btn btn-blue center",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (quickBooksAuthCheck()))
              }, " Check Quickbooks connection "),
              (urlForAuth.value)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 2,
                    href: urlForAuth.value,
                    class: "btn",
                    target: "_blank",
                    rel: "noopener noreferrer"
                  }, "Regenerate Quickbooks connection", 8, _hoisted_3))
                : _createCommentVNode("", true),
              (successQuickbooks.value)
                ? (_openBlock(), _createElementBlock("p", _hoisted_4, " Successfully Connected "))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (!activeTab.value)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _hoisted_5,
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  (_unref(userData).has_storage_access)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        class: "box-link",
                        onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (
              _unref(router).push({ name: 'Home', query: { tab: 'storage' } })
            ), ["prevent"]))
                      }, _hoisted_9))
                    : _createCommentVNode("", true),
                  (_unref(userData).has_campground_access)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 1,
                        class: "box-link",
                        onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (
              _unref(router).push({ name: 'Home', query: { tab: 'campground' } })
            ), ["prevent"]))
                      }, _hoisted_11))
                    : _createCommentVNode("", true)
                ])
              ])
            ], 64))
          : _createCommentVNode("", true),
        (activeTab.value === 'storage' && _unref(userData).has_storage_access)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _hoisted_12,
              (_unref(userData).facilities)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((searchFacility).value = $event)),
                        type: "text",
                        style: {"max-width":"600px"},
                        placeholder: "Search...",
                        onKeyup: _cache[4] || (_cache[4] = _withKeys(($event: any) => (search()), ["enter"]))
                      }, null, 544), [
                        [_vModelText, searchFacility.value]
                      ]),
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((selectedFilter).value = $event)),
                        class: "form-select",
                        style: {"max-width":"210px"}
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filterOptions.value, (filter) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: filter + 'filter',
                            value: filter.value,
                            onKeyup: _cache[5] || (_cache[5] = _withKeys(($event: any) => (search()), ["enter"]))
                          }, _toDisplayString(filter.text), 41, _hoisted_15))
                        }), 128))
                      ], 512), [
                        [_vModelSelect, selectedFilter.value]
                      ]),
                      _createElementVNode("button", {
                        class: "btn",
                        onClick: search,
                        onKeyup: _cache[7] || (_cache[7] = _withKeys(($event: any) => (search()), ["enter"]))
                      }, " Search ", 32)
                    ]),
                    (status.value === 'loading')
                      ? (_openBlock(), _createBlock(_component_BaseSpinner, {
                          key: 0,
                          preset: "large"
                        }))
                      : _createCommentVNode("", true),
                    (filteredFacilities.value && filteredFacilities.value.length != 0)
                      ? (_openBlock(), _createElementBlock("table", _hoisted_16, [
                          _hoisted_17,
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredFacilities.value, (facility) => {
                            return (_openBlock(), _createElementBlock("tr", {
                              key: facility.id + 'facility'
                            }, [
                              _createElementVNode("td", null, [
                                _createVNode(_component_RouterLink, {
                                  to: {
                  name: 'customers',
                  params: {
                    facilityId: facility.id.toString(),
                    facilityName: facility.api_name,
                  },
                }
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(facility.facility_name), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["to"])
                              ]),
                              _createElementVNode("td", null, _toDisplayString(facility.phone_number), 1)
                            ]))
                          }), 128))
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_18, "No results found"))
                  ]))
                : _createCommentVNode("", true)
            ], 64))
          : _createCommentVNode("", true),
        (activeTab.value === 'campground' && _unref(userData).has_campground_access)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
              _hoisted_19,
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((searchCampground).value = $event)),
                    type: "text",
                    style: {"max-width":"600px"},
                    placeholder: "Search Campgrounds...",
                    onKeyup: _cache[9] || (_cache[9] = _withKeys(($event: any) => (searchCampgrounds()), ["enter"]))
                  }, null, 544), [
                    [_vModelText, searchCampground.value]
                  ]),
                  _createElementVNode("button", {
                    class: "btn",
                    onClick: searchCampgrounds
                  }, "Search")
                ]),
                (campgroundStatus.value === 'loading')
                  ? (_openBlock(), _createBlock(_component_BaseSpinner, {
                      key: 0,
                      preset: "large"
                    }))
                  : _createCommentVNode("", true),
                (filteredCampgrounds.value && filteredCampgrounds.value.length != 0)
                  ? (_openBlock(), _createElementBlock("table", _hoisted_22, [
                      _hoisted_23,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredCampgrounds.value, (camp) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: camp.id + 'campground'
                        }, [
                          _createElementVNode("td", null, [
                            _createVNode(_component_RouterLink, {
                              to: {
                  name: 'nb_bookings',
                  params: {
                    facilityId: camp.id.toString(),
                    facilityName: camp.facility_name,
                  },
                }
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(camp.facility_name), 1)
                              ]),
                              _: 2
                            }, 1032, ["to"])
                          ]),
                          _createElementVNode("td", null, _toDisplayString(formatPhoneNumber(camp.phone_number)), 1)
                        ]))
                      }), 128))
                    ]))
                  : (campgroundStatus.value === 'loaded')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_24, " No campground facilities found "))
                    : _createCommentVNode("", true)
              ])
            ], 64))
          : _createCommentVNode("", true),
        (formErrors.value.errors)
          ? (_openBlock(), _createBlock(_component_BaseAlert, {
              key: 4,
              variant: "danger",
              class: "js-form-error",
              dismissible: "",
              onDismissed: _cache[10] || (_cache[10] = ($event: any) => (formErrors.value = {}))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(formErrors.value.errors), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ], 64))
    : _createCommentVNode("", true)
}
}

})